// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashedButton-dashed-3fc2{padding:3px;padding-right:7px;border:1px dashed var(--ui-border-color-secondary)}.DashedButton-stand-3fc2{gap:8px;padding:0}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/basic/DashedButton.module.scss"],"names":[],"mappings":"AAAA,0BACE,WAAA,CACA,iBAAA,CACA,kDAAA,CAGF,yBACE,OAAA,CACA,SAAA","sourcesContent":[".dashed {\n  padding: 3px;\n  padding-right: 7px;\n  border: 1px dashed var(--ui-border-color-secondary);\n}\n\n.stand {\n  gap: 8px;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashed": `DashedButton-dashed-3fc2`,
	"stand": `DashedButton-stand-3fc2`
};
module.exports = ___CSS_LOADER_EXPORT___;
